export default __webpack_public_path__ + "static/media/p30.6f1fec6c.jpg";